module.exports = __webpack_public_path__ + "static/media/Klavika_Regular_Italic.401ab4f2.woff";